<template>
  <div>
    <el-card class="box-card" body-style="min-height:70vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="分销员名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入分销员名称/手机号搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="userId"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="headPicture"
            label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;border-radius: 40px;"
                :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
                :preview-src-list="[scope.row.headPicture]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="enterpriseName"
            label="分公司">
            <template slot-scope="scope">
              <span>{{scope.row.enterpriseName == '' || scope.row.enterpriseName == null ? '--' : scope.row.enterpriseName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="referenceNumber"
            label="下级总数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="addUpCommissionMoney"
            label="累计佣金">
          </el-table-column>
          <el-table-column
            align="center"
            prop="commissionMoney"
            label="可提现金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="toCreditedCommissionMoney"
            label="待入账">
          </el-table-column>
          <el-table-column
            align="center"
            prop="applyWithdrawalMoney"
            label="提现中">
          </el-table-column>
          <el-table-column
            align="center"
            prop="promotionTime"
            width="130"
            label="成为推广员时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="200"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toLowerLevelBtn(scope.row.userId)" type="text" size="small">下级人员</el-button>
              <el-button @click="toOrderBtn(scope.row.userId)" type="text" size="small">推广订单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryOneUserCommissionManagePageList } from '@/api/commission'
export default {
  name: 'CommissionMember',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryOneUserCommissionManagePageList({ webCommissionSearchStr: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 跳转推广订单页面 */
    toOrderBtn(infoId){
      this.$router.push({path: '/commission_order', query: {dataId: infoId}})
    },
    /* 跳转下级人员页面 */
    toLowerLevelBtn(infoId){
      this.$router.push({path: '/lower_level', query: {dataId: infoId}})
    },
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/Member.vue